export default "__VITE_ASSET__f43968f2__"